/**
 * Checks if an object is empty
 */
export default function isEmpty(obj: Record<string, unknown>) {
    for (const prop in obj) {
        if (Object.hasOwn(obj, prop)) {
            return false;
        }
    }

    return true;
}
